export const bookBoxItems = [
  {
    id: '1',
    name: 'Enchanted Realms Box',
    theme: 'Fantasy',
    coverImage:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    price: 39.99,
    subscriptionType: 'monthly',
    status: 'active',
    releaseDate: '2024-01-01',
    genre: 'Fantasy',
    description:
      'A monthly box filled with fantasy novels, bookmarks, and themed merchandise.',
    isSpecialEdition: false,
  },
  {
    id: '2',
    name: 'Dark Romance Deluxe',
    theme: 'Dark Romance',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 49.99,
    subscriptionType: 'monthly',
    status: 'active',
    releaseDate: '2024-01-01',
    genre: 'Romance',
    description:
      'Curated dark romance reads with exclusive author-signed editions.',
    isSpecialEdition: false,
  },
  {
    id: '3',
    name: 'Mystery & Mayhem',
    theme: 'Mystery Thriller',
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 34.99,
    subscriptionType: 'quarterly',
    status: 'active',
    releaseDate: '2024-01-01',
    genre: 'Mystery',
    description: 'Quarterly mystery and thriller box with exclusive content.',
    isSpecialEdition: false,
  },
  {
    id: '4',
    name: 'Sci-Fi Odyssey',
    theme: 'Science Fiction',
    coverImage:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1050&q=80',
    price: 44.99,
    subscriptionType: 'monthly',
    status: 'active',
    releaseDate: '2024-02-01',
    genre: 'Sci-Fi',
    description:
      'Science fiction adventures with exclusive prints and collectibles.',
    isSpecialEdition: false,
  },
  {
    id: '5',
    name: 'Horror Nights',
    theme: 'Horror',
    coverImage:
      'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 39.99,
    subscriptionType: 'monthly',
    status: 'retired',
    releaseDate: '2023-10-01',
    genre: 'Horror',
    description: 'A Halloween-themed horror box (now retired).',
    isSpecialEdition: false,
  },
  {
    id: '6',
    name: 'Romance Bloom',
    theme: 'Contemporary Romance',
    coverImage:
      'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 36.99,
    subscriptionType: 'monthly',
    status: 'retired',
    releaseDate: '2023-06-01',
    genre: 'Romance',
    description: 'Contemporary romance with floral-themed accessories.',
    isSpecialEdition: false,
  },
  {
    id: '7',
    name: "Enchanted Realms: Collector's Edition",
    theme: 'Fantasy',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 89.99,
    subscriptionType: 'one-time',
    status: 'active',
    releaseDate: '2024-03-01',
    genre: 'Fantasy',
    description:
      "Limited collector's edition with foiled covers and exclusive art prints.",
    isSpecialEdition: true,
  },
  {
    id: '8',
    name: 'Dark Romance: Anniversary Box',
    theme: 'Dark Romance',
    coverImage:
      'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 79.99,
    subscriptionType: 'one-time',
    status: 'active',
    releaseDate: '2024-02-14',
    genre: 'Romance',
    description:
      "Valentine's Day special edition with exclusive signed copies.",
    isSpecialEdition: true,
  },
  {
    id: '9',
    name: 'YA Adventure Box',
    theme: 'Young Adult',
    coverImage:
      'https://images.unsplash.com/photo-1515876305430-f06edab8282a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 29.99,
    subscriptionType: 'monthly',
    status: 'active',
    releaseDate: '2024-01-01',
    genre: 'Young Adult',
    description: 'Young adult adventures with bookmarks and character art.',
    isSpecialEdition: false,
  },
  {
    id: '10',
    name: 'Historical Fiction Vault',
    theme: 'Historical',
    coverImage:
      'https://images.unsplash.com/photo-1551029506-0807df4e2031?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    price: 42.99,
    subscriptionType: 'quarterly',
    status: 'active',
    releaseDate: '2024-01-01',
    genre: 'Historical',
    description:
      'Quarterly historical fiction with period-accurate accessories.',
    isSpecialEdition: false,
  },
]
